const CumulativeReturnTable = require('okCharts/CumulativeReturnTable');

module.exports = CumulativeReturnTable;
